import { connect } from 'react-redux';
import CompaniesCreditsList from "./CompaniesCreditsList";
import { getTranslation } from "../../../../reducers/common/localization";
import {
    showModal,
    MODAL_COMPANIES_CREDITS_CONTACT_DATA,
    MODAL_COMPANY_CREDITS_HISTORY_MODAL
} from '../../../../reducers/common/activeModal';
import {
    getCompaniesCreditsData,
    loadingCompaniesCredits,
    fetchGetCompaniesCredits,
    getCompaniesCreditsSorting,
    updateCompaniesCreditsSorting,
    getCompaniesCreditsNameFilter,
    updateCompaniesCreditsNameFilter,
    onUpdateCompanyCreditsCountryFilter,
    onUpdateCompanyCreditsCountryFilterByContinent,
    setSelectedCompanyId,
    onFetchGetCompanyHistory, setSelectedCompanyName
} from '../../../../reducers/systemPayments/companiesCredits';
import {getLocationData} from '../../../../reducers/common/location';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        loading: loadingCompaniesCredits(state),
        data: getCompaniesCreditsData(state),
        sorting: getCompaniesCreditsSorting(state),
        nameFilter: getCompaniesCreditsNameFilter(state),
        locationData: getLocationData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetCompaniesCredits());
        },
        onShowContactDataModal: () => {
            dispatch(showModal({ modalKey: MODAL_COMPANIES_CREDITS_CONTACT_DATA }))
        },
        onChangeSorting: (sorting) => {
            dispatch(updateCompaniesCreditsSorting(sorting))
        },
        onChangeNameFilter: (name) => {
            dispatch(updateCompaniesCreditsNameFilter(name))
        },
        onChangeContinentFilter: (continent) => {
            dispatch(onUpdateCompanyCreditsCountryFilterByContinent(continent));
        },
        onChangeCountryFilter: (country) => {
            dispatch(onUpdateCompanyCreditsCountryFilter(country));
        },
        onShowHistoryModal: (id, name) => {
            dispatch(showModal({ modalKey: MODAL_COMPANY_CREDITS_HISTORY_MODAL }));
            dispatch(setSelectedCompanyId(id));
            dispatch(setSelectedCompanyName(name));
            dispatch(onFetchGetCompanyHistory(0, id));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesCreditsList);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/companiesCreditsList/CompaniesCreditsList.container.js